module.exports = __webpack_public_path__ + "static/media/right-arrow.32b45095.svg";